document.addEventListener(
	'DOMContentLoaded',
	() => {
		const tabs = Array.from(document.querySelectorAll('.category-posts__heading__buttons button'));
		const tabsContent = document.querySelector('.category-posts__posts');

		// Function to update the active tab and its content position
		const updateTabs = (activeTab) => {
			// Deactivate all tabs and activate the clicked one
			tabs.forEach((t) => t.classList.remove('active'));
			activeTab.classList.add('active');

			// Adjust content position based on active tab
			tabsContent.style.transform = `translateX(-${tabsContent.offsetWidth * tabs.indexOf(activeTab)}px)`;
		};

		// Add click event to each tab
		tabs.forEach((tab) => tab.addEventListener('click', () => updateTabs(tab)));

		// Update content position on window resize to maintain layout integrity
		window.addEventListener('resize', () => {
			const activeTab = tabs.find((tab) => tab.classList.contains('active'));
			if (activeTab) updateTabs(activeTab);
		});
	},
	false,
);
